import { Component, computed, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SpecialInformationBarService } from '@app/modules/special-information/special-information-bar.service';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { BaseInformationBar } from '../base-information-type.component';

/**
 * The payroll contact setup banner shown when a payroll contact is not configured
 */
@Component({
    selector: 'special-info-payroll-contact-setup',
    standalone: true,
    imports: [PlatformModule, TranslateModule, RouterModule],
    templateUrl: './payroll-contact-setup-info-bar.template.html',
})
export class SpecialInfoPayrollContactSetup extends BaseInformationBar {
    shouldDisplay: Signal<boolean> = computed(() => {
        const { isAdmin, hasPayroll, hasPayrollAdminContact, isEmployeeOnboarding } = this.displayConditions() || {};

        // Don't show if employee is onboarding
        if (isEmployeeOnboarding) {
            return false;
        }

        // Show for admins who have payroll access but don't have a payroll admin contact
        return !!(isAdmin && hasPayroll && hasPayrollAdminContact === false);
    });

    constructor(specialInformationBarService: SpecialInformationBarService) {
        super(specialInformationBarService);
    }
}
